module.exports = __webpack_public_path__ + "media/images/magnus-08dc33401496d6fe2aa2388ffbe1de3b.jpg";